<template>
  <div>
    <inside-header />
    <div>
      我从不轻易认输，直到陪孩子读书我从不轻易认输，直到陪孩子读书
    </div>
    <hr>
    <div />
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  components: {
    InsideHeader
  }
}
</script>
<style scoped>

</style>
